import React from "react";
import "./Payment_Success_Modal.css";
import Successfull_Lottie from "../../animation/Successfull_Lottie/Successfull_Lottie";

function Payment_Success_Modal({ successText, ...props }) {
  return (
    <>
      <section className="Success_modal Payment_Success_Modal">
        <Successfull_Lottie successText="Order Placed Successfully" />
      </section>
    </>
  );
}

export default Payment_Success_Modal;
